import React, {Component} from "react";
import { Route, Switch, withRouter } from 'react-router-dom';
import Receive from "./receive/Receive";
import Associate from "./associate/Associate";
import LineHaulDetail from "./linehaul/LineHaulDetail";
import Induct from "./induct/Induct";
import Package from "./package/Package";
import {publishCountToCSM} from "./util/Util";

function publishRoutePath(location) {
    const metricProcessName = "SCC_INDUCT";
    const metricName = location.pathname;
    publishCountToCSM({
        processName: metricProcessName,
        metricName: metricName
    });
}

class App extends Component {

    componentWillMount() {
        publishRoutePath(this.props.location);
        this.onRouteSwitch = this.props.history.listen(() => {
            publishRoutePath(this.props.location);
        });
    }
    componentWillUnmount() {
        this.onRouteSwitch();
    }

    render() {
        return (

                <Switch>
                    <Route path="/receive" component={Receive} />
                    <Route path="/associate" component={Associate} />
                    <Route path="/linehaulDetail/:lineHaulId/:origin/:arrivalTime/:departTime" component={LineHaulDetail} />
                    <Route path="/induct" component={Induct} />
                    <Route exact path="/packageList/:lineHaulId" component={Package} />
                    <Route exact path="/packageList/:lineHaulId/:containerId/:packageState/:filter/:path" component={Package} />
                </Switch>
        )
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/app.js